module.exports = __webpack_public_path__ + "static/media/quick_actions_bg.352396ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/inar2/images/quick_actions_bg.jpg
// module id = 1517
// module chunks = 0